var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg__brand",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m39.732 70.16l3-2.597 3.845-3.327-3.845-3.068-3-2.394-19.564-15.611h-14.727l24.879 19.854c.349.278.555.697.564 1.143.009.446-.181.873-.518 1.164l-25.18 21.798h14.953l19.598-16.962"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m57.27 11.975h-14.538v45.35l6.738 5.379 7.8-5.995z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m42.732 87.13h14.538v-14.93l-7.8-6.5-6.738 5.83z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m68.62 63l25.807-19.837h-14.615l-19.548 15.03-3 2.306-4.868 3.742 4.868 4.059 3 2.501 19.582 16.325h14.853l-26.12-21.78c-.35-.292-.548-.727-.539-1.182.009-.456.224-.883.585-1.16"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/brand.adf1781bb5bea62510e45678ed0ddc8d.svg";
export { ForwardRef as ReactComponent };